import * as iapRuleset from './iap.ruleset';
import * as iapSchema from './iap.schema';
import * as iapUtil from './iap.util';
import * as iapModifiers from './iap.modifiers';
import { Inventory } from '../buruburu/inventory';
import { ReplicantModuleState } from '../utils';
import { Immutable } from '@play-co/replicant';
import { iapActions } from './iap.actions';

export type { ProductId, ProductRewardType } from './iap.ruleset';

export type Iap = typeof Iap;
// eslint-disable-next-line no-redeclare
export namespace Iap {
  export const $DEPENDENCIES = { Inventory };

  export const ruleset = iapRuleset;
  export const schema = iapSchema;
  export const api = {
    ...iapUtil,
    ...iapModifiers,
  };
  export const actions = iapActions;

  export type MutableState = ReplicantModuleState<Iap>;
  export type State = Immutable<MutableState>;
}
